import $http from '../../utils/http';
import $httpPost from '../modules/complaintApis/http'
let appraise = 'tio/assessManagement';
//获取用户信息
const getUserInfo = params => {
  return $http({
    url: appraise + '/login/getLoginInfo',
    headers: { 'showLoading': false },
    params
  })
}
//获取首页 通知公告
const getNotify = params => {
  return $http({
    url: appraise + '/api/notice/findAllNotice',
    headers: { 'showLoading': false },
    params
  })
}
// 获取季度 年份
const getQuarters = params => {
  return $http({
    url: appraise + "/api/areaDictionary/findQuarters",
    headers: { 'showLoading': false },
    params
  })
}
// 获取 城市 列表
const getCityList = params => {
  return $http({
    url: appraise + "/api/areaDictionary/findCitys",
    headers: { 'showLoading': false },
    params
  })
}

//获取省级首页列表
const getAssessScoreList = params => {
  return $http({
    url: appraise + "/api/unitmonitorassess/findAssessScore",
    headers: { 'showLoading': true },
    params
  })
}
// 获取省级详情页  或者  直接获取 州市详情页
const getAssessScoreDay = params => {
  return $http({
    url: appraise + '/api/assessscore/queryAssessScoreDay',
    headers: { 'showLoading': true },
    params
  })
}
//获取 综合监管考核子项 列表
const getdeductionList = params => {
  return $http({
    url: appraise + '/api/unitmonitorassess/findUnitMonitor',
    headers: { 'showLoading': true },
    params
  })
}

//查 A1 A2 的详情
const getDetailByA1A2 = params => {
  return $http({
    url: appraise + "/api/unitmonitorassess/getDetail",
    headers: { 'showLoading': true },
    params
  })
}
//查 A3 的详情
const getDetailByA3 = params => {
  return $http({
    url: appraise + "/api/unitmonitorassess/getDetailByA3",
    headers: { 'showLoading': true },
    params
  })
}

//退回
const checkAuthBack = data => {
  return $httpPost({
    url: appraise + "/api/unitmonitorassess/goBack",
    headers: { 'showLoading': true },
    data,
    method: 'POST'
  })
}
// A1 A2 删除附件
const deleteFileA1A2 = data => {
  return $httpPost({
    url: appraise + "/api/unitmonitorassess/delFile",
    headers: { 'showLoading': true },
    data,
    method: 'POST',
  });
}
//A3 新增附件，编辑附件
const uploadByLawCaseA3 = data => {
  return $httpPost({
    url: appraise + "/api/unitmonitorassess/uploadByLawCase",
    headers: { 'showLoading': true },
    data,
    method: 'POST',
  });
}
//A3 新增附件，编辑附件
const delFileByLawCaseA3 = data => {
  return $httpPost({
    url: appraise + "/api/unitmonitorassess/delFileByLawCase",
    headers: { 'showLoading': true },
    data,
    method: 'POST',
  });
}
// 获取cos token
const getCOStoken = params => {
  return $http({
    url: appraise + "/file/cos/token",
    headers: { 'showLoading': false },
    params,
  })
}
// 获取 按钮权限，控制按钮是否要显示
const getAuthtoBTN = params => {
  return $http({
    url: appraise + '/login/getSubmitsAudits',
    headers: { 'showLoading': false },
    params,
  })
}

//先 A1 A2的附件
const uploadFiel = data => {
  return $httpPost({
    url: appraise + "/api/unitmonitorassess/uploadFiles",
    headers: { 'showLoading': true },
    data,
    method: 'POST',
  })
}
// 再 上报
const submitFiel = data => {
  return $httpPost({
    url: appraise + "/api/unitmonitorassess/submit",
    headers: { 'showLoading': true },
    data,
    method: 'POST',
  })
}
// 审核
const authing = data => {
  return $httpPost({
    url: appraise + "/api/unitmonitorassess/audit",
    headers: { 'showLoading': true },
    data,
    method: 'POST',
  })
}

// const upoadFielInves = params =
//获取附件类型
const getFileKind = params => {
  return $http({
    url: appraise + "/api/sys/property/fileKind",
    headers: { 'showLoading': false },
    params,
  })
}

// 投诉件管理模块

const getComplainData = params => {
  return $http({
    url: appraise + "/api/complainInfo/getComplainData",
    // headers: { 'showLoading': false },
    params,
  })
}
// 任务管理模块
// 关闭审核
const turnOffAudit = data => {
  return $httpPost({
    url: appraise + "/api/sys/property/turnOffAudit",
    headers: { 'showLoading': false },
    data,
    method: 'POST'
  })
}
// 关闭填报
const turnOffApply = data => {
  return $httpPost({
    url: appraise + "/api/sys/property/turnOffApply",
    headers: { 'showLoading': false },
    data,
    method: 'POST'
  })
}
// 打开审核
const turnOnAudit = data => {
  return $httpPost({
    url: appraise + "/api/sys/property/turnOnAudit",
    headers: { 'showLoading': false },
    data,
    method: 'POST'
  })
}
// 打开填报
const turnOnApply = data => {
  return $httpPost({
    url: appraise + "/api/sys/property/turnOnApply",
    headers: { 'showLoading': false },
    data,
    method: 'POST'
  })
}
/** 获取季度接口 */
const queryQuarters = params => {
  return $http({
    url: appraise + '/api/areaDictionary/findQuarters',
    params,
  })
}
// 获取对应季度的开关状态
const switchStatus = params => {
  return $http({
    url: appraise + '/api//sys/property/switchStatus',
    params,
  })
}
/** 涉旅安全事故发生情况  */
// 涉旅安全详情 GET /api/tripAccident/getDetail
const querySaveDetail = params => {
  return $http({
    url: appraise + '/api/tripAccident/getDetail',
    params,
  })
}
// 涉旅安全生产主列表
const findAllTripAccident = params => {
  return $http({
    url: appraise + '/api/tripAccident/findAllTripAccident',
    params,
  })
}
// 涉旅安全生产列表
const querySaveList = params => {
  return $http({
    url: appraise + '/api/tripAccident/get',
    params,
  })
}
// 涉旅安全删除
const deleteTripAccident = data => {
  return $httpPost({
    url: appraise + '/api/tripAccident/del',
    data,
    method: 'POST'
  })
}
// 涉旅安全新增
const createTripAccident = data => {
  return $httpPost({
    url: appraise + '/api/tripAccident/create',
    data,
    method: 'POST'
  })
}
// 涉旅安全审核
const auditTripAccident = data => {
  return $httpPost({
    url: appraise + '/api/tripAccident/audit',
    data,
    method: 'POST'
  })
}
/** 涉旅负面舆情 api */
// 负面舆情审核P
const badOpinionAudit = data => {
  return $httpPost({
    url: appraise + '/api/tripBadOpinion/audit',
    data,
    method: 'POST'
  })
}
// 新增涉旅负面舆情
const badOpinionCreate = data => {
  return $httpPost({
    url: appraise + '/api/tripBadOpinion/create',
    data,
    method: 'POST'
  })
}
// 新增涉旅负面舆情
const badOpinionDel = data => {
  return $httpPost({
    url: appraise + '/api/tripBadOpinion/del',
    data,
    method: 'POST'
  })
}
// 涉旅负面舆情列表查询
const findAllTripBadOpinion = params => {
  return $http({
    url: appraise + '/api/tripBadOpinion/findAllTripBadOpinion',
    params,
  })
}
// 涉旅负面舆情二级列表
const getAllTripBadOpinion = params => {
  return $http({
    url: appraise + '/api/tripBadOpinion/get',
    params,
  })
}
// 涉旅负面舆情列表详情
const getOpinionDetail = params => {
  return $http({
    url: appraise + '/api/tripBadOpinion/getAreaDetail?',
    params,
  })
}
// 审核涉旅负面舆情获取比例
const getOpinionRate = params => {
  return $http({
    url: appraise + '/api/tripBadOpinion/getRate',
    params,
  })
}

/** 上级通报批评约谈 */
// 收到上级批评审核
const leaderNoticeAudit = data => {
  return $httpPost({
    url: appraise + '/api/leaderNoticeMeet/audit',
    data,
    method: 'POST'
  })
}
// 收到上级批评新增
const leaderNoticeCreate = data => {
  return $httpPost({
    url: appraise + '/api/leaderNoticeMeet/create',
    data,
    method: 'POST'
  })
}
// 收到上级批评删除
const leaderNoticeDel = data => {
  return $httpPost({
    url: appraise + '/api/leaderNoticeMeet/del',
    data,
    method: 'POST'
  })
}
// 收到上级批评列表
const findAllLeaderNoticeMeet = params => {
  return $http({
    url: appraise + '/api/leaderNoticeMeet/findAllLeaderNoticeMeet',
    params
  })
}
// 收到上级批评列表
const findLeaderNoticeMeet = params => {
  return $http({
    url: appraise + '/api/leaderNoticeMeet/findLeaderNoticeMeet',
    params
  })
}
// 收到上级批评二级列表
const getLeaderNotice = params => {
  return $http({
    url: appraise + '/api/leaderNoticeMeet/get',
    params
  })
}
// 收到上级批评详情
const getNoticeDetail = params => {
  return $http({
    url: appraise + '/api/leaderNoticeMeet/getDetail',
    params
  })
}
/** 通知公告  */
// 新增通知公告
const createNotice = data => {
  return $httpPost({
    url: appraise + '/api/notice/create',
    data,
    method: 'POST'
  })
}
// 删除通知公告
const delNotice = data => {
  return $httpPost({
    url: appraise + '/api/notice/delNotice',
    data,
    method: 'POST'
  })
}
// 删除通告附件
const delNoticeFile = data => {
  return $httpPost({
    url: appraise + '/api/notice/delNoticeFile',
    data,
    method: 'POST'
  })
}
// 通知公告列表
const findAllNotice = params => {
  return $http({
    url: appraise + '/api/notice/findAllNotice',
    params
  })
}
// 通知公告表详情
const getNoticeDesc = params => {
  return $http({
    url: appraise + '/api/notice/get',
    params
  })
}
// 通知公告表详情
const getNotReadMsg = params => {
  return $http({
    url: appraise + '/api/notice/getNotReadMsg',
    params
  })
}
// 通告表发布
const submitNotice = data => {
  return $httpPost({
    url: appraise + '/api/notice/submit',
    data,
    method: 'POST'
  })
}
// 通告表更新
const updateNotice = data => {
  return $httpPost({
    url: appraise + '/api/notice/updateReadMsg',
    data,
    method: 'POST'
  })
}
// 更新信息已读
const updateReadMsg = data => {
  return $httpPost({
    url: appraise + '/api/notice/updateReadMsg',
    data,
    method: 'POST'
  })
}

/** 批量审核列表 */
const queryCheckList = params => {
  return $http({
    url: appraise + '/api/assessscore/queryAuditList',
    params
  })
}
// 游客投诉处置体系运行情况审核操作
const complainDealCheck = data => {
  return $httpPost({
    url: appraise + '/api/complainDeal/audit',
    data,
    method: 'POST'
  })
}
// 游客投诉率
const touristComplainRateCheck = data => {
  return $httpPost({
    url: appraise + '/api/touristComplainRate/audit',
    data,
    method: 'POST'
  })
}
// 游客投诉处置效率
const touristComplainRate = data => {
  return $httpPost({
    url: appraise + '/api/complainDoneRate/audit',
    data,
    method: 'POST'
  })
}
// 游客投诉处置满意度
const complainDoneSatisfy = data => {
  return $httpPost({
    url: appraise + '/api/complainDoneSatisfy/audit',
    data,
    method: 'POST'
  })
}
// 游客体验满意度
const touristExpSatisfy = data => {
  return $httpPost({
    url: appraise + '/api/touristExpSatisfy/audit',
    data,
    method: 'POST'
  })
}
// 投诉5分钟内未响应情况
const findAllBy5minutes = params => {
  return $http({
    url: appraise + '/api/complainDeal/findAllBy5minutes',
    params
  })
}
// 投诉超过24小时未办结情况
const findAllBy24hourOutstanding = params => {
  return $http({
    url: appraise + '/api/complainDeal/findAllBy24hourOutstanding',
    params
  })
}
// 投诉办结率24小时未达95%
const findAllBy95Outstanding = params => {
  return $http({
    url: appraise + '/api/complainDeal/findAllBy95Outstanding',
    params
  })
}
// 游客投诉率列表数据
const findAllTouristComplainRate = params => {
  return $http({
    url: appraise + '/api/touristComplainRate/findAllTouristComplainRate',
    params
  })
}
// 游客投诉处置效率列表数据
const findAllComplainDoneRate = params => {
  return $http({
    url: appraise + '/api/complainDoneRate/findAllComplainDoneRate',
    params
  })
}
// 游客投诉处置满意度列表数据
const findAllComplainDoneSatisfy = params => {
  return $http({
    url: appraise + '/api/complainDoneSatisfy/findAllComplainDoneSatisfy',
    params
  })
}
// 游客体验满意度列表数据
const findAllTouristExpSatisfy = params => {
  return $http({
    url: appraise + '/api/touristExpSatisfy/findAllTouristExpSatisfy',
    params
  })
}

/** 企业诚信评价 */
// 涉旅企业诚信评价 api
const queryIntegrityList = params => {
  return $http({
    url: appraise + '/api/integrityAssess/get',
    params,
    method: 'GET'
  })
}
/**  获取城市列表 */
const queryCityList = params => {
  return $http({
    url: appraise + '/api/areaDictionary/findCitys',
    params
  })
}

// “1+16+129+X”游客投诉处置运行情况
const findAllForApp = params => {
  return $http({
    url: appraise + '/api/complainDeal/findAllForApp',
    params
  })
}
// 5分钟   24小时
const getComplainById = params => {
  return $http({
    url: appraise + '/api/complainInfo/getComplainById',
    params
  })
}
// 超过95%   
const getComplainDealById = params => {
  return $http({
    url: appraise + '/api/complainDeal/getComplainDealById',
    params
  })
}

// 投诉5分钟内未响应
const getComplainByB1 = params => {
  return $http({
    url: appraise + '/api/complainDeal/findAllForAppByB1',
    params
  })
}
//投诉超过24小时未办结情况
const getComplainByB2 = params => {
  return $http({
    url: appraise + "/api/complainDeal/findAllForAppByB2",
    params
  })
}
// 投诉办结率24小时未达95%
const getComplainByB3 = params => {
  return $http({
    url: appraise + "/api/complainDeal/findAllForAppByB3",
    params
  })
}

// 游客投诉处置效率详情
const complainDone = params => {
  return $http({
    url: appraise + '/api/complainDoneRate/getDetailForApp',
    params
  })
}
// 游客投诉处置满意度 
const complainDoneRate = params => {
  return $http({
    url: appraise + '/api/complainDoneSatisfy/getDetailForApp',
    params
  })
}
// 游客投诉率详情
const touristComplain = params => {
  return $http({
    url: appraise + '/api/touristComplainRate/getDetailForApp',
    params
  })
}
// 游客体验满意度详情 
const touristExperience = params => {
  return $http({
    url: appraise + '/api/touristExpSatisfy/getDetailForApp',
    params
  })
}
// 5分钟投诉列表
export const checkListNotRespondDetail = params => {
  return $http({
    url: appraise + 'api/complainInfo/notRespondDetail',
    params,
  })
}
// 24小时投诉列表
export const checkListNotFinishedDetail = params => {
  return $http({
    url: appraise + 'api/complainInfo/notFinishedDetail',
    params,
  })
}

/** add by 2024年 10 月 */
//获取首页列表
const findUnitMonitorAssessData = params => {
  return $http({
    url: appraise + "/admin/report/findUnitMonitorAssessData",
    headers: { 'showLoading': true },
    params
  })
}

//获取 获取州市考核大项目 2018 admin/report/findTourismAppraisalResult?quarter=1&year=2018
const findTourismAppraisalResult = params => {
  return $http({
    url: appraise + "/admin/report/findTourismAppraisalResult",
    headers: { 'showLoading': true },
    params
  })
}

//获取 获取州市考核 大项目 2019之后 
const findRegulatoryCheckResult = params => {
  return $http({
    url: appraise + "/admin/report/findRegulatoryCheckResult",
    headers: { 'showLoading': true },
    params
  })
}

// 获取综合监控 A1子项详情 
const getDetailByACategory = params => {
  return $http({
    url: appraise + "/admin/unitmonitorassess/getDetail",
    headers: { 'showLoading': true },
    params
  })
}
//  获取 B 考核项 扣分列表
const getBCateogryDeductionList = params => {
  return $http({
    url: appraise + "/admin/complainDeal/getComplainScore",
    headers: { 'showLoading': true },
    params
  })
}
//  获取 投诉增长率
const findAllComplainUpRate = params => {
  return $http({
    url: appraise + "/admin/touristComplainRate/findAllComplainUpRate",
    headers: { 'showLoading': true },
    params
  })
}

//  获取 30 天无理由退货情况
const getRefundScore = params => {
  return $http({
    url: appraise + "/api/refund/score",
    headers: { 'showLoading': true },
    params
  })
}

/** 投诉信息列表 **/
export function getCityRefundDealPageList(params) {
  return $http({
    url: appraise +`/refund/pageList/${params.currentPage}/${params.pageSize}`,
    headers: { 'showLoading': true },
    params: params.data,
  })
}

/** 投诉信息列表 **/
export function getCityComplainDealPageList(params) {
  return $http({
    url: appraise +`/admin/complainInfo/pageList/${params.currentPage}/${
      params.pageSize
    }`,
    headers: { 'showLoading': true },
    params: params.data,
  })
}
export default {
  getUserInfo,
  getNotify,
  getQuarters,
  getDetailByA3,
  uploadByLawCaseA3,
  delFileByLawCaseA3,
  getAssessScoreList,
  getDetailByA1A2,
  getCityList,
  getAssessScoreDay,
  getdeductionList,
  uploadFiel,
  getCOStoken,
  getAuthtoBTN,
  submitFiel,
  authing,
  queryQuarters,
  switchStatus,
  getComplainData,
  turnOffAudit,
  turnOffApply,
  turnOnAudit,
  turnOnApply,
  querySaveDetail,
  findAllTripAccident,
  querySaveList,
  deleteTripAccident,
  createTripAccident,
  auditTripAccident,
  badOpinionAudit,
  badOpinionCreate,
  badOpinionDel,
  findAllTripBadOpinion,
  getAllTripBadOpinion,
  getOpinionDetail,
  getOpinionRate,
  leaderNoticeAudit,
  leaderNoticeCreate,
  leaderNoticeDel,
  findAllLeaderNoticeMeet,
  findLeaderNoticeMeet,
  getLeaderNotice,
  getNoticeDetail,
  queryIntegrityList,
  createNotice,
  delNotice,
  delNoticeFile,
  findAllNotice,
  getNoticeDesc,
  getNotReadMsg,
  submitNotice,
  updateNotice,
  updateReadMsg,
  queryCheckList,
  complainDealCheck,
  touristComplainRateCheck,
  touristComplainRate,
  complainDoneSatisfy,
  touristExpSatisfy,
  findAllBy5minutes,
  findAllBy24hourOutstanding,
  findAllBy95Outstanding,
  findAllTouristComplainRate,
  findAllComplainDoneRate,
  findAllComplainDoneSatisfy,
  findAllTouristExpSatisfy,
  queryCityList,
  getFileKind,
  findAllForApp,
  getComplainById,
  getComplainDealById,
  complainDone,
  complainDoneRate,
  touristComplain,
  touristExperience,
  checkListNotRespondDetail,
  checkListNotFinishedDetail,
  getComplainByB1,
  getComplainByB2,
  getComplainByB3,
  checkAuthBack,
  deleteFileA1A2,
  findUnitMonitorAssessData,
  findTourismAppraisalResult,
  findRegulatoryCheckResult,
  getDetailByACategory,
  getBCateogryDeductionList,
  findAllComplainUpRate,
  getRefundScore,
  getCityRefundDealPageList,
  getCityComplainDealPageList
}
